export default __webpack_public_path__ + "static/media/item5.e082b68c.png";